import { render, staticRenderFns } from "./PInfo.vue?vue&type=template&id=04bb7114&scoped=true"
import script from "./PInfo.vue?vue&type=script&lang=js"
export * from "./PInfo.vue?vue&type=script&lang=js"
import style0 from "./PInfo.vue?vue&type=style&index=0&id=04bb7114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb7114",
  null
  
)

export default component.exports